import * as React from "react";
import { useInstitutions } from "../../../context/InstitutionsContext";
import { EditableField } from "../../../components/editable-field";

export interface IInstitutionsSelectProps {
  value: number;
  onChange: (e: React.ChangeEvent<HTMLElement>) => void;
}

export function InstitutionsSelect({
  value,
  onChange,
}: IInstitutionsSelectProps) {
  const { institutions } = useInstitutions();
  return (
    <EditableField
      label="Barra Pesquera"
      value={value}
      onChange={onChange}
      required
      type="select"
      name="institution_id"
      placeholder="Seleccione una barra pesquera"
      options={institutions.map((institution) => ({
        key: String(institution.institution.id),
        value: institution.institution.name,
      }))}
    />
  );
}
